import { Button, Grid, Row } from '@rocketmakers/armstrong';
import * as React from 'react';
import { DeviceType, RuleCategory } from '../../../../shared/api-clients/_api';
import { useRoutePaths } from '../../../../shared/context/paths';
import { BackButton } from '../../components/buttons/back-button';
import { DeviceSummary } from '../../components/layout/deviceSummary/device-summary';
import { Spinner } from '../../components/spinner/spinner';
import { useBeeConfig } from '../../hooks/beeConfig';
import { routePaths } from '../../routes';
import './add-meters.scss';
import { InlineMeterDevice, inlineMeterTypes } from './types';

const SUPPORTED_DEVICE_TYPES = [DeviceType.IEM2055, DeviceType.IEM2155];

export const AddInlineMetersView: React.FunctionComponent = () => {
  const { push } = useRoutePaths();
  const { devices, getDevicesByType, loading, getDevicesByCategory, updateConfig } = useBeeConfig();

  const inlineMeters = React.useMemo(() => getDevicesByType<InlineMeterDevice>(inlineMeterTypes), [devices]).filter(d =>
    SUPPORTED_DEVICE_TYPES.includes(d.deviceType)
  );

  const handleAdd = () => push(routePaths.inlineMeters.configure);

  const handleContinue = async () => {
    const ctMeters = getDevicesByCategory(RuleCategory.ELECTRICITY).filter(
      d => !SUPPORTED_DEVICE_TYPES.includes(d.deviceType)
    );
    await updateConfig({ devicesToRemove: ctMeters });
    push(routePaths.heatAndFlowMeters.root);
  };

  return (
    <div className="data-table">
      {loading && <Spinner />}
      <BackButton />
      <h3>
        Configuration <span className="color-primary">What meters are in the household?</span>
      </h3>
      <Grid className="grid">
        <Row>
          {inlineMeters?.map(device => (
            <DeviceSummary
              key={device.params.circuit_label}
              fields={[
                { name: 'Type:', value: device.params.circuit_type },
                { name: 'Meter Amp:', value: device.params.meter_amperage },
                { name: 'MODBUS:', value: device.params.address },
              ]}
              onSelect={() => {
                push(routePaths.inlineMeters.edit, { deviceLabel: device.params.circuit_label }, device);
              }}
              name={device.params.circuit_label}
              data-qa={`device-summary-${device.params.circuit_label}`}
            />
          ))}
        </Row>
      </Grid>
      <Button className="continue-button btn-full btn-large" onClick={handleAdd} data-qa="add-button-inline-meter">
        Add a circuit
      </Button>
      <Button
        disabled={!devices || devices.length < 1}
        className="continue-button btn-full btn-large"
        onClick={handleContinue}
        data-qa="continue-button"
      >
        Continue
      </Button>
    </div>
  );
};
